export class FoodSpecies {

  readonly lbsExempt: boolean;

  readonly localNames: string;

  readonly name: string;

  constructor(readonly id: number) {
  }

}
